import axios from "axios";
import {
  getHttpProtocol as scheme,
  getCommunicationsServiceUrl as communicationServiceUrl,
} from "../utils/requests";
import { refreshAccessTokenInterceptor } from "../utils/refreshTokens";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../utils/axios.utils";

// custom axios
const communicationsAxios = axios.create({
  baseURL: `${scheme}//${communicationServiceUrl}`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

communicationsAxios.interceptors.request.use(requestAccessTokenInterceptor);

communicationsAxios.interceptors.request.use(refreshAccessTokenInterceptor);

communicationsAxios.interceptors.response.use(responseStatusInterceptor);

// Dynamo communications
export type Communication = {
  clicks: string[];
  clientId: string;
  contentUrl: string;
  createdAt: string;
  deliveredAt?: string;
  id: string;
  messageType: "EMAIL" | "SMS";
  openIpAddress: string;
  openedAt?: string;
  sentAt?: string;
  subject: string;
  updatedAt: string;
  userId: string;
};
export type ClientUserCommunicationResponse = {
  data: Communication[];
};

export async function getClientUserCommunications(
  clientUuid: string,
  userUuid: string,
): Promise<Communication[]> {
  const url = `/${clientUuid}/user/${userUuid}/communications`;
  const response = await communicationsAxios.get<{
    data: Communication[];
  }>(url);
  return response.data.data;
}
